var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#check-circle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.003 1.333A6.67 6.67 0 0 0 1.336 8a6.669 6.669 0 0 0 6.667 6.666A6.67 6.67 0 0 0 14.669 8a6.67 6.67 0 0 0-6.666-6.667Zm0 12A5.34 5.34 0 0 1 2.669 8a5.34 5.34 0 0 1 5.334-5.334A5.34 5.34 0 0 1 13.336 8a5.34 5.34 0 0 1-5.333 5.333Zm3.06-8.28L6.669 9.446l-1.726-1.72-.94.94 2.666 2.667L12.003 6l-.94-.947Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "check-circle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgCheckCircle;